exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".vm-container .description-box {\n  border-top: 1px solid #eee;\n  border-bottom: 1px solid #eee;\n  margin: 0 0 0 0;\n  padding: 10px 5px; }\n\n.vm-container .vm-manage-vcloud div {\n  border-bottom: 1px solid #eee;\n  padding: 8px 0; }\n  .vm-container .vm-manage-vcloud div a {\n    color: #0E82BD;\n    font-size: 12px;\n    text-decoration: none;\n    cursor: pointer;\n    text-transform: uppercase; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/compute/compute-vcd/vm/vm.scss
// module id = kDpy
// module chunks = 0